const LOCAL_DEV_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);

const CANONICAL_CUSTOM_AUTH_DOMAINS = new Map([
  ["teachleague.com", "teachleague.com"],
  ["www.teachleague.com", "teachleague.com"],
  ["missingvoices.app", "missingvoices.app"],
  ["www.missingvoices.app", "missingvoices.app"],
]);

export const isLocalDevelopmentHost = (hostname = "") =>
  LOCAL_DEV_HOSTS.has(String(hostname || "").toLowerCase());

export const resolveFirebaseAuthDomain = (
  hostname = "",
  fallbackAuthDomain = ""
) => {
  const normalizedHost = String(hostname || "").trim().toLowerCase();
  const normalizedFallback = String(fallbackAuthDomain || "").trim();

  if (!normalizedHost || isLocalDevelopmentHost(normalizedHost)) {
    return normalizedFallback;
  }

  return (
    CANONICAL_CUSTOM_AUTH_DOMAINS.get(normalizedHost) || normalizedFallback
  );
};
